export default __webpack_public_path__ + "static/media/refresh.891aa155.svg";